import { createScopedReducer } from '@mews-commander/utils';
import { GUESTS_DIALOG_OPENED, GUESTS_DIALOG_CLOSED } from '../../actionTypes';

export const NAME = 'guestsDialog';

const initialState = {
    isOpen: false,
};

export const guestsDialogReducer = createScopedReducer(initialState, {
    [GUESTS_DIALOG_OPENED]: () => ({
        isOpen: true,
    }),
    [GUESTS_DIALOG_CLOSED]: () => ({
        isOpen: false,
    }),
});
